var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalDotsCondensed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7403.57,-1410.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle-black",
    transform: "matrix(0.145417,0,0,0.186342,7000.04,1351.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-48137.9,-7254.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7421.57,1433.15C7421.57,1432.04 7420.68,1431.15 7419.57,1431.15C7418.47,1431.15 7417.57,1432.04 7417.57,1433.15C7417.57,1434.25 7418.47,1435.15 7419.57,1435.15C7420.68,1435.15 7421.57,1434.25 7421.57,1433.15ZM7421.57,1426.89C7421.57,1425.79 7420.68,1424.89 7419.57,1424.89C7418.47,1424.89 7417.57,1425.79 7417.57,1426.89C7417.57,1427.99 7418.47,1428.89 7419.57,1428.89C7420.68,1428.89 7421.57,1427.99 7421.57,1426.89ZM7421.57,1420.63C7421.57,1419.53 7420.68,1418.63 7419.57,1418.63C7418.47,1418.63 7417.57,1419.53 7417.57,1420.63C7417.57,1421.74 7418.47,1422.63 7419.57,1422.63C7420.68,1422.63 7421.57,1421.74 7421.57,1420.63Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotsCondensed);
export default __webpack_public_path__ + "static/media/vertical_dots_condensed.c84036d0cdfaeb9d8149fb5778b8f148.svg";
export { ForwardRef as ReactComponent };